// Margines bezpieczeństwa: token uznajemy za wygasły nieco przed faktycznym
// `exp`, żeby nie wysyłać żądania, które i tak wróci z 401 (rozjazd zegara
// przeglądarki vs serwera, czas przelotu żądania).
const TOKEN_EXPIRY_LEEWAY_SECONDS = 30

// JWT koduje nagłówek i payload w base64url (RFC 4648 §5): '-' zamiast '+',
// '_' zamiast '/' i bez dopełnienia '='. atob() wymaga zwykłego base64.
function base64UrlDecode(value) {
    let base64 = String(value).replace(/-/g, '+').replace(/_/g, '/')
    while (base64.length % 4 !== 0) {
        base64 += '='
    }
    const binary = window.atob(base64)
    // atob() zwraca ciąg bajtów (latin1), a JWT jest kodowany w UTF-8 — bez tej
    // konwersji znaki spoza ASCII (np. w nazwie użytkownika) byłyby zniekształcone.
    try {
        return decodeURIComponent(binary.split('').map(function (char) {
            return '%' + ('00' + char.charCodeAt(0).toString(16)).slice(-2)
        }).join(''))
    } catch (e) {
        return binary
    }
}

var jwtService = {
    getAccessToken() {
        return localStorage.getItem('access_token')
    },
    setAccessToken(token) {
        localStorage.setItem('access_token', token);
    },
    getRefreshToken() {
        return localStorage.getItem('refresh_token')
    },
    setRefreshToken(token) {
        localStorage.setItem('refresh_token', token);
    },
    getUsername() {
        return localStorage.getItem('username')
    },
    setUsername(username) {
        localStorage.setItem('username', username);
    },
    getRoles() {
        // Uszkodzona wartość (ręczna edycja, starsza wersja panelu) nie może
        // wywracać guardu routera, który woła tę metodę przy każdej nawigacji.
        try {
            return JSON.parse(localStorage.getItem('roles'));
        } catch (e) {
            return null;
        }
    },
    setRoles(roles) {
        localStorage.setItem('roles', JSON.stringify(roles));
    },
    setPasswordChangeRequired(required) {
        localStorage.setItem('password_change_required', required ? 'true' : 'false');
    },
    isPasswordChangeRequired() {
        return localStorage.getItem('password_change_required') === 'true';
    },
    isPasswordChangeRequiredSet() {
        // getItem zwraca null, gdy klucz nie istnieje (nigdy pusty string)
        return localStorage.getItem('password_change_required') !== null;
    },
    // Zwraca payload tokenu albo null, gdy token jest pusty, nie jest JWT-em
    // (trzy człony) albo payload nie daje się zdekodować / sparsować.
    // Nie weryfikuje podpisu — to robi API; tutaj chodzi wyłącznie o `exp`.
    decodeToken(token) {
        if (typeof token !== 'string' || token.split('.').length !== 3) {
            return null
        }
        try {
            const payload = JSON.parse(base64UrlDecode(token.split('.')[1]))
            return (payload && typeof payload === 'object') ? payload : null
        } catch (e) {
            return null
        }
    },
    // Token bez czytelnego `exp` (brak tokenu, uszkodzony, nie-JWT) traktujemy
    // jak wygasły — bezpieczniej wysłać użytkownika na logowanie niż pokazać
    // mu panel, którego API i tak nie obsłuży.
    isTokenExpired(token) {
        const payload = this.decodeToken(token)
        if (!payload || typeof payload.exp !== 'number') {
            return true
        }
        return payload.exp <= (Date.now() / 1000) + TOKEN_EXPIRY_LEEWAY_SECONDS
    },
    isAccessTokenExpired() {
        return this.isTokenExpired(this.getAccessToken())
    },
    isRefreshTokenExpired() {
        return this.isTokenExpired(this.getRefreshToken())
    },
    // Czy sesja da się jeszcze uratować: jest access token i przynajmniej jeden
    // z tokenów żyje. Sam wygasły access to nie problem — interceptor w http.js
    // wymieni go na nowy, dopóki refresh token jest ważny.
    hasRestorableSession() {
        if (!this.getAccessToken()) {
            return false
        }
        return !this.isAccessTokenExpired() || !this.isRefreshTokenExpired()
    },
    setLoginData(accessToken, refreshToken, username, roles) {
        this.setAccessToken(accessToken)
        this.setRefreshToken(refreshToken)
        this.setUsername(username)
        this.setRoles(roles)
    },
    removeLoginData() {
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('username');
        localStorage.removeItem('roles');
        localStorage.removeItem('password_change_required');
    }
}

export default jwtService
